export enum EnumDispatchState {
  GeneradoXML = 1,
  EnviadoXML = 2,
  RespuestaXML = 3,
  Finalizado = 4,
  Error = 5,
  Iniciado = 6
}
